import { enqueueSnackbar } from 'notistack';
import axiosInstance, { endpoints } from 'src/utils/axios';

export async function getAllFormations(userID) {
  // console.log( `Envoi d'une requête pour récupérer les intervenant de l'organisme avec ID ${userID}` );
  try {
    const response = await axiosInstance.get(`${endpoints.formations.getAllSession}/${userID}`);
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function getAllFormationsFromDemandPAge(userID) {
  // console.log( `Envoi d'une requête pour récupérer les intervenant de l'organisme avec ID ${userID}` );
  try {
    const response = await axiosInstance.get(`${endpoints.formations.getAllSessionDemad}/${userID}`);
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function getReservationList(formationsSessionObject) {
  // console.log("Envoi d'une requête pour supprimer  l'utilisateur:", formationsSessionObject.sessionID, formationsSessionObject.userID);
  try {
    const response = await axiosInstance.get(`${endpoints.formations.reservationsList}/${formationsSessionObject.sessionID}/organizations/${formationsSessionObject.userID}`);
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function updateStatut(statutObject) {
  // console.log("Envoi changer le statut de la session de formation d'un utilisateur:", statutObject);
  try {
    const response = await axiosInstance.post(endpoints.formations.ChangeStatut, {
      ...statutObject,
    });
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function updateFormationStatut(statutObject) {
  // console.log("Envoi changer le statut de la session de formation d'une  formation:", statutObject);
  try {
    const response = await axiosInstance.post(endpoints.formations.updateFormationStatut, {
      ...statutObject,
    });
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function archiveFormation(sessionIdObject) {
  // console.log("archivage d'une  formation:", sessionIdObject);
  try {
    const response = await axiosInstance.post(endpoints.formations.archive, {
      ...sessionIdObject,
    });
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}
